import StartPage from './Pages/StartPage';

export default function App() {
  
  return (
    <div>
        <StartPage />
    </div>
  );
}
